<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <loading v-if="loading" :text="'Please wait'|translate"></loading>
      <div v-if="page">
        <h3 style="margin-top:0px;">{{page.title}}</h3>
        <div class="detail mb10" v-html="page.description"></div>
      </div>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import Loading from "@/components/elements/Loading";

export default {
  name: "Page",
  components: {
    MyHeader,
    Loading
  },
  data() {
    return {
      loading: true,
      page: null
    };
  },
  watch: {
    $route(to, from) {
      this.page = null;
      this.loadPage();
    }
  },
  methods: {
    loadPage() {
      this.loading = true;
      this.slug = this.$route.params.slug;
      Utils.requestV2(this, true)
        .get(`/posts/${this.slug}`)
        .then(response => {
          this.loading = false;
          let data = response.data;
          this.page = data;
          this.page.description = this.page.description.replace(
            "&lt;iframe",
            "<iframe"
          );
          this.page.description = this.page.description.replace(
            "&gt;&lt;/iframe&gt;",
            "></iframe>"
          );
        })
        .catch(error => {
          this.loading = false;
          Utils.showErrorMessage(this, error.response);
        });
    }
  },
  mounted() {
    this.loadPage();
    // $('html, body').animate({ scrollTop: 0 });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Page.vue